import { Component, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, SimpleChanges, Inject, Optional, AfterViewInit } from '@angular/core';
import { FileProvider } from '../file.provider';
import { StoredFile } from '../../model/file';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { FileAction, FileDialog } from './file.dialog';
import { FileUploadDialog, UploadData } from '../file.upload/file.upload.dialog';
import { I18N, SessionProvider } from 'ess-plugin-base';
import { UIService } from '../../ui.service';
import { FileHandle } from '../../tools/filedrop.directive';
import { FileShareDialog } from './share.dialog';
import { FolderDialog } from '../file.tree/folder.dialog';

@Component({
    selector: 'file-list',
    templateUrl: './file.list.html',
    styleUrls: ['./file.list.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    providers: [FileProvider]
})
export class FileList implements OnChanges, AfterViewInit {

    @Input()
    folder_id: number;

    @Input()
    path: string = '';

    @Input()
    resource: string = '';

    @Input()
    folders: StoredFile[] = [];

    @Input()
    files: StoredFile[] = [];

    @Input('toolbar-visible')
    toolbarVisible: boolean = true;

    @Input('up-link-visible')
    upLinkVisible: boolean = false;

    @Input('fileTypes')
    fileTypes: any = {};   //Map<string, string> = new Map<string, string>();

    /*Nobel 2025-08-18 Shady Files*/
    @Input()
    rename: boolean = false

    @Input()
    del: boolean = false

    @Input()
    transfer: boolean = false

    @Input()
    shar: boolean = false;

    @Input()
    showFolders: boolean = false;

    @Output('open')
    onOpen: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @Output('select')
    onSelect: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @Output('change')
    onChange: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    root: string = '';      //'D://';

    cols: number = 1;

    previewDiv: HTMLElement | null;

    // stack: number[] = [];

    constructor(
        private fileProvider: FileProvider,
        private dialog: MatDialog,
        private ui: UIService,
        public i18n: I18N,
        @Optional() public dialogRef: MatDialogRef<FileList>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        debugger;
        if (data != null) {
            debugger;
            this.path = data.path;
            this.resource = data.resource;
            this.folder_id = data.folder_id;
            this.toolbarVisible = data.toolbarVisible;
            this.upLinkVisible = data.upLinkVisible;
            this.rename = data.rename;
            this.del = data.del;
            this.transfer = data.transfer;
            this.shar = data.shar;
            this.reload();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        //console.log("Changes to file list", changes);

        if (changes.path || changes.resource || changes.folder_id) {
            debugger;
            // if (changes.path.previousValue != changes.path.currentValue) {
            this.reload();
            // }
        }
    }

    ngAfterViewInit() {
        // Get a reference to the preview div after the view has been initialized
        this.previewDiv = document.getElementById('preview');
    }

    onResize(event) {
        this.cols = (event.target.innerWidth <= 600) ? 1 : 2;
    }

    reload() {
        if (!this.resource || !this.resource.length) return;
        // console.log(this.path + this.resource);

        // let fnames: Set<string> = new Set<string>();
        let latest: StoredFile = null;

        // this.fileProvider.exploreFiles(this.folder_idthis.root + this.path, this.resource)
        this.fileProvider.getFiles(this.folder_id, this.resource, this.path)
            .then(data => {
                // this.folders = [];
                this.files = [];
                for (let f of data) {
                    // if (f.isDirectory()) {
                    //     this.folders.push(f);
                    // } else {
                    if (latest && latest.filename == f.filename) {
                        latest.versions.push(f);
                    } else {
                        //fnames.add(f.filename);
                        latest = f;
                        this.files.push(f);
                    }
                    // }
                }
                // this.files = data;
            });

        this.fileProvider.getFolders(this.folder_id, this.resource)
            .then(data => {
                this.folders = [];
                // this.files = [];
                for (let f of data) {
                    // if (f.isDirectory()) {
                    this.folders.push(f);
                    // } else {
                    //     this.files.push(f);
                    // }
                }

                // this.files = data;
            });
    }

    notifyChange(file: StoredFile) {
        this.onChange.emit(file);
    }

    enter(file: StoredFile) {
        if (file) {
            if (this.path.length) {
                this.path = this.path + '/' + file.filename;
            } else {
                this.path = file.filename;
            }
            this.folder_id = file.id;
            this.reload();

        } else {
            // go up one level..
            let index = this.path.lastIndexOf('/');
            if (index < 0) {
                this.path = ''; //return;
            }
            this.path = this.path.slice(0, index);
            // this.folder_id = this.stack.pop();

            this.fileProvider.getFolder(this.folder_id)
                .then(curr => {
                    if (curr) {
                        this.folder_id = curr.infolder;
                        this.reload();
                    } else {
                        console.log("Error going to " + this.folder_id);
                    }
                })
        }
    }

    select(file: StoredFile) {
        if (file && file.guid && this.onSelect.observers.length) {
            this.onSelect.emit(file);
        }
    }

    open(file: StoredFile) {
        if (file && file.guid && this.onOpen.observers.length) {
            this.onOpen.emit(file);
        }
        // if (file.size > 0) {
        //     // a file
        //     console.log(file.versions);
        // }
    }

    isMapped(file: StoredFile) {
        if (file && file.filename) {
            let ext = this.fileProvider.getExtension(file);
            if (ext) return !!this.fileTypes[ext];      //.get(ext);
        }
        return null;
    }

    edit(file: StoredFile) {
        let action = (file.isDirectory()) ? FileAction.RENAME_FOLDER : FileAction.RENAME_FILE;
        let title = 'file.rename_file';
        if (file.isDirectory()) title = 'file.rename_folder';
        if (!file.filename || !file.filename.length) {
            action = FileAction.NEW_FOLDER;
            title = 'file.new_folder';
        }

        this.touch(file, action, title)
    }

    delete(file: StoredFile) {
        let action = (file.isDirectory()) ? FileAction.DELETE_FOLDER : FileAction.DELETE_FILE;
        let title = (file.isDirectory()) ? 'file.delete_folder' : 'file.delete_file';

        this.touch(file, action, title);
    }

    touch(file: StoredFile, action: FileAction, title: String) {
        debugger;
        // console.log("Editing", file);
        if (!file || !file.guid) {
            return;
        }

        const dialogRef = this.dialog.open(FileDialog, {
            width: '50%', height: 'auto',
            data: { path: file.path, name: file.filename, guid: file.guid, title: title, action: action }
        });

        dialogRef.afterClosed().subscribe(result => {
            // console.log("dialog returned " + result);
            debugger;
            if (result && result == '__DELETE__') {
                this.fileProvider.delete(file.isDirectory() ? 'folder' : 'file', file.guid, file.filename, this.resource, this.folder_id)
                    .then(ok => {
                        if (ok) {
                            this.reload();
                            this.notifyChange(file);
                        }
                    })
                    .catch(err => {
                        this.ui.error(this.i18n.get('file_dialog_error_delete', 'Error deleting this item.'))
                    })
            }
            else
                if (result && result != '') {
                    // console.log(result);
                    // if (result.contains('/')) {
                    //     result = result.substring(result.lastIndexOf('/') + 1);
                    // }
                    this.fileProvider.rename(file.isDirectory() ? 'folder' : 'file', file.guid, file.filename, result, this.resource, this.folder_id)
                        .then(ok => {
                            if (ok) {
                                this.reload();
                                this.notifyChange(file);
                            }
                        })
                        .catch(err => {
                            this.ui.error(this.i18n.get('file_dialog_error_rename', 'Error renaming this item.'))
                        })
                }
        });
    }

    move(file: StoredFile) {
        if (!file || !file.guid) {
            return;
        }
        // prevent selecting the same folder (or a child)
        let disabled_id = (file.isDirectory()) ? file.id : null;

        const dialogRef = this.dialog.open(FolderDialog, {
            width: '50%', height: 'auto',
            data: {
                resource: this.resource,
                title: file.filename,
                disabled_id: disabled_id
            }
        });

        dialogRef.afterClosed().subscribe((result: StoredFile) => {
            if (result && result.id) {
                // console.log(result);
                // if (result.contains('/')) {
                //     result = result.substring(result.lastIndexOf('/') + 1);
                // }
                this.fileProvider.move(file, result, this.resource)
                    .then(ok => {
                        if (ok) {
                            this.reload();
                            this.notifyChange(file);

                            this.ui.success(this.i18n.get('file_move_success', 'Moving successful'));
                        } else {
                            this.ui.error(this.i18n.get('file_move_error', 'Error moving file(s).'))
                        }
                    })
                    .catch(err => {
                        this.ui.error(this.i18n.get('file_move_error', 'Error moving file(s).'))
                    })
            }
        });
    }

    share(file: StoredFile) {
        if (!file || !file.guid) {
            return;
        }
        const dialogRef = this.dialog.open(FileShareDialog, {
            width: '50%', height: 'auto',
            data: {
                files: [file.guid],
                resources: [],
                title: file.filename,
                path: 'Shared/' + (SessionProvider.user.full_name || SessionProvider.user.username)
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            //     // console.log("dialog returned " + result);

            //     if (result && result == '__DELETE__') {
            //         this.fileProvider.delete(file.isDirectory() ? 'folder' : 'file', file.guid, file.filename, this.resource, this.folder_id)
            //         .then(ok => {
            //             if (ok) this.reload();
            //         })
            //         .catch(err => {
            //             this.ui.error( this.i18n.get('file_dialog_error_delete', 'Error deleting this item.'))
            //         })
            //     }
            //     else
            if (result && result.resources && result.resources.length) {
                // console.log(result);
                // if (result.contains('/')) {
                //     result = result.substring(result.lastIndexOf('/') + 1);
                // }
                this.fileProvider.share(result)
                    .then(ok => {
                        if (ok) {       //this.reload();
                            this.ui.success(this.i18n.get('share_dialog_success', 'Sharing successful'));
                        } else {
                            this.ui.error(this.i18n.get('share_dialog_error', 'Error sharing file(s).'))
                        }
                    })
                    .catch(err => {
                        this.ui.error(this.i18n.get('share_dialog_error', 'Error sharing file(s).'))
                    })
            }
        });
    }

    newFolder() {
        const dialogRef = this.dialog.open(FileDialog, {
            width: '50%', height: 'auto',
            data: { path: this.path, folder: this.folder_id, name: '', action: 'New Folder' }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (!result || !result.length || result == this.path) {
                return;
            }
            if (this.path.startsWith('/')) {
                this.path = this.path.substring(1);
            }
            if (result.startsWith('/')) {
                result = result.substring(1);
            }

            this.fileProvider.newFolder(this.folder_id, result, this.resource)
                .then(new_id => {
                    this.reload();
                    this.notifyChange(null);
                    // if (new_id) {
                    //     this.path = result;
                    //     this.folder_id = +new_id;
                    //     this.folders = [];
                    //     this.files = [];
                    // }
                })
                .catch(err => {
                    this.ui.error(this.i18n.get('file_dialog_error_create_folder', 'Error creating folder.'))
                })
        });
    }

    upload(files: File[]) {
        // let dialogRef = this.dialog.open(FileUploadDialog, { width: '50%', height: '50%' });
        const dialogRef = this.dialog.open(FileUploadDialog, {
            width: '50%', height: '50%',
            data: { path: this.path, folder: this.folder_id, resource: this.resource, files: files }
        });

        dialogRef.afterClosed().subscribe(result => {
            // if (!result || !result.length || result == this.path) {
            //     return;
            // }
            // if (this.path.startsWith('/')) {
            //     this.path = this.path.substring(1);
            // }

            this.reload();
            // fileProvider.newFolder(result, this.resource)
            // .then(ok => {
            //     this.path = result;
            //     this.folders = [];
            //     this.files = [];
            // })
        });
    }

    dropFiles(event: FileHandle[]) {
        let ups: File[] = [];
        for (let handle of event) {
            ups.push(handle.file);
        }
        this.upload(ups);
    }

    mimeTypeMap: Record<string, string> = {
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'jpe': 'image/jpeg',
        'jfif': 'image/jpeg',
        'png': 'image/png',
        'gif': 'image/gif',
        'webp': 'image/webp',
        'svg': 'image/svg+xml',
        'bmp': 'image/bmp',
        'tiff': 'image/tiff',
        'tif': 'image/tiff',
        'ico': 'image/x-icon'
    };

    previewFile(filex: any) {
        debugger
        if (!this.previewDiv) {
            console.error('Preview div not found!');
            return;
        }

        const previewDiv = this.previewDiv;

        previewDiv.innerHTML = '';
        const fileName = (filex.name || filex.filename).toLowerCase();
        const fileType = this.mimeTypeMap[fileName.split('.').pop().toLowerCase()];
        
        this.fileProvider.downloadBlob(filex).then((file: Blob) => {
            debugger;

            const reader = new FileReader();
            let _file: Blob;

            if (fileName.endsWith('.pdf')) {
                _file = new Blob([file], { type: 'application/pdf' });
            } else if (fileType && fileType.startsWith('image/')) {
                _file = new Blob([file], { type: fileType });
            } else {
                previewDiv.innerText = 'File type not supported for preview.';
                return;
            }
            reader.onload = () => {
                const dataUrl = reader.result as string;
                if (fileName.endsWith('.pdf')) {
                    const iframe = document.createElement('iframe');
                    iframe.src = dataUrl;
                    iframe.style.width = '100%';
                    iframe.style.height = '100%';
                    iframe.style.border = 'none';
                    previewDiv.appendChild(iframe);
                } else if (fileType && fileType.startsWith('image/')) {
                    const img = document.createElement('img');
                    img.src = dataUrl;
                    img.style.maxWidth = '100%';
                    img.style.maxHeight = '100%';
                    img.style.objectFit = 'contain';
                    previewDiv.appendChild(img);
                }
            };
            reader.readAsDataURL(_file);
        });
    }

    cancel() {
        this.dialogRef.close();
    }
}